// extracted by mini-css-extract-plugin
export default {"centerImagesContainer":"CenterImages_centerImagesContainer__Qe1F8","centerFruit":"CenterImages_centerFruit__GyZql","centerVegetables":"CenterImages_centerVegetables__pHKz0"};